import { Component, Input } from '@angular/core';

@Component({
    selector: 'finder-filter-button',
    templateUrl: './filter-button.component.html',
    styleUrls: ['./filter-button.component.scss']
})
export class FilterButtonComponent {

    @Input() id: string;
    @Input() ariaLabel;
    @Input() icon;
    @Input() selected = false;
    @Input() shrink = false;

    constructor() { }

}
